import { numberToTimeCounter } from '@vindr/utils/converter';
import classnames from 'classnames';
import { useCaptureState } from '../context';
import './TimeElapsed.css';

const TimeElapsed = () => {
  const { mediaRecorder, elapsedTime } = useCaptureState();

  return (
    <div
      className={classnames(
        'record-timer absolute top-0 left-1/2 flex items-center justify-center',
        {
          'recording': ['recording', 'paused'].includes(mediaRecorder?.state),
        }
      )}
    >
      <div
        className={classnames('record-icon', {
          'recording': mediaRecorder?.state === 'recording',
          'paused': mediaRecorder?.state === 'paused',
        })}
      />
      <p className={'time-elapsed'}>{numberToTimeCounter(elapsedTime)}</p>
    </div>
  );
};

export default TimeElapsed;
